import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e495a8cc")

_pushScopeId("data-v-e495a8cc")
const _hoisted_1 = {
  key: 0,
  class: "listState"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Loading...", -1)
const _hoisted_4 = {
  key: 1,
  class: "listState"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "icon-clear" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Aucune requête enregistrée", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UserCard = _resolveComponent("UserCard")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.pendingUserLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3
        ]))
      : (_ctx.pendingUserReady && !_ctx.pendingUsers.length)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6
          ]))
        : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pendingUsers, (user) => {
      return (_openBlock(), _createBlock(_component_UserCard, {
        key: user._id,
        user: user,
        canDelete: !_ctx.isSelf(user._id),
        canConfirm: true,
        canEdit: false,
        onUserDelete: _ctx.denyPendingUser,
        onUserConfirm: _ctx.confirmPendingUser
      }, null, 8, ["user", "canDelete", "onUserDelete", "onUserConfirm"]))
    }), 128))
  ]))
})